import dynamic from "next/dynamic";

export const DynamicContent025 = dynamic(() => import("./Content025"), {
  suspense: true,
});
